import apiSR from '@/api/sr';
import apiOption from '@/api/option';
import apiCustomer from '@/api/customer'
import apiScan from '@/api/scanSerial'

const defaultState = () => ({
	listSR: [],
	detailSR: {},
	listProduct: [],
	srPagination: '',
	OptionPaymentMethod: [],
	OptionFreeTools: [],
	warehouseResults: [],
	customerDetail: {},
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: '',
});

const state = defaultState();

const getters = {
};

const mutations = {
	setSR(state, data) {
		state.listSR = data.data
		state.srPagination = data.pagination;
	},
	setDetailSR(state, data) {
		state.detailSR = data
	},
	setProduct(state, data) {
		state.listProduct = data.map( (el) => {
			el.selected = false
			el.quantity = '1'
			el.serial = []

      if (el.product_is_serial) {
        el.product_is_serial = JSON.parse(el.product_is_serial)
      }

      if (el.is_include) {
        el.is_include = JSON.parse(el.is_include)
      }

      if (typeof el.product_is_serial == 'object' && el.product_is_serial) {
        el.product_is_serial = el.product_is_serial.map(el2 => {
          el2.serial = ''
          el2.serial_array = []
          return el2
        })
      }
			return el
		});
	},
	setOptionFreeTools (state, data) {
		state.OptionFreeTools = data
	},
	setPaymentMethod(state, data) {
		state.OptionPaymentMethod = data
	},
	setDetailCustomer(state, data) {
		state.customerDetail = data
	},
	setWarehouse(state, data) {
		state.warehouseResults = data
	},
	saveResponse(state, data) {
		state.response = data
		state.responseError = {}
		state.alertMultiple = []
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataSR(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getSR({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSR.getSR(params).then(({ data: { data } }) => {
				commit('setSR', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				commit('setSR', { data: [], pagination: {} });
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getSRAll({ dispatch, commit }, params) {
		apiSR.getSRAll(params).then(({ data: { data } }) => {
			commit('setSR', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setSR', { data: [], pagination: {} });
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	getDetailSR({ commit, dispatch }, params) {
		apiSR.getDetailSR(params).then(({ data: { data } }) => {
			commit('setDetailSR', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailSR', {});
		});
	},
	getOptionProduct({ commit }) {
		apiOption.getOptionProductToSell().then(({ data: { data } }) => {
			commit('setProduct', data.results);
		}).catch(() => {
			commit('setProduct', []);
		});
	},
	getOptionPaymentMethod({ commit }) {
		apiOption.getOptionPaymentMethod().then(({ data: { data } }) => {
			commit('setPaymentMethod', data.results);
		}).catch(() => {
			commit('setPaymentMethod', []);
		});
	},
	getOptionFreeTools({ dispatch, commit }) {
		apiOption.getOptionFreeTools().then(({ data: { data: { results } } }) => {
			commit('setOptionFreeTools', results);
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	getWarehouseOption({ commit }, params){
		return new Promise((resolve) => {
			apiOption.getOptionWarehouse(params).then(({ data: { data } }) => {
				commit('setWarehouse', data.results);
				resolve()
			}).catch(() => {
				commit('setWarehouse', []);
			});
		});
	},
	async exportSR({ dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSR.exportSR(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportSRAll({ dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSR.exportSRAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
		await dispatch('attempted', null, { root: true })
	},
	async detailCustomer({ dispatch, commit }, params) {
		await apiCustomer.getDetailCustomerByMid(params).then(({ data: { data } }) => {
			commit('setDetailCustomer', data.results);
		}).catch((err) => {
			commit('setDetailCustomer', {});
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	async createSR({ commit, dispatch }, params) {
		await apiSR.createSR(params).then( res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async scanLinkSerial({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiScan.scanLinkSerial(params).then( res => {
				const data = res.data;
				commit("saveResponse", data);
				// dispatch('success', data)
				resolve(data)
			})
			.catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data)
				reject(err)
			});
		})
	},
	scanSerial({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiSR.scanSerial({
				serial: params.serial,
				card_type: params.card_type,
				is_serial: params.type,
				arr_serial: params.arr_serial,
			}).then( ( { data : { data } } ) => {
				var serialSuccess = data.results.filter((el) => {
					return el.status == "available" && el.type == params.type
				})

				var serialFailed = data.results.filter((el) => {
					return el.status != "available" || el.type != params.type
				})
				var res = {
					success: serialSuccess.map((el) => {
						return el.serial
					}),
					failed : serialFailed.reduce((r, a) => {
						r[a.note] = [...r[a.note] || [], a.serial];
						return r;
					}, {})
				}
				if (serialSuccess.length > 0)
					resolve(res)
				else
					reject(res)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		});
	},
	searchMemberMLM({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiCustomer.searchMemberMLM(params).then(({ data: { data }  }) => {
				resolve(data.results)
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject()
			});
		})
	},
	sendEmailSerial({ dispatch }, params) {
		return new Promise(async (resolve, reject) => {
			await dispatch('isAttempting', null, { root: true })
			await apiSR.sendEmailSerial(params).then(res => {
				const data = res.data;
				dispatch('success', data.message, { root: true })
				resolve(true)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data, { root: true })
				reject(false)
			});
			await dispatch('attempted', null, { root: true })
		})
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
